<template>
    <div class="proposal-form">
        <ModelString
            class="model-item"
            label="Планируемое название проекта"
            data-voicetext="Планируемое название проекта"
            required
            :value="proposal.name"
            @change="setUpdate('name', $event)"
            :disabled="disabled"
            :valid="isFieldValid['name']"
        />
        <ModelMultiAutoComplete
            class="model-item"
            label="Целевая аудитория"
            data-voicetext="Целевая аудитория"
            required
            itemValue="id"
            itemText="field_value"
            :value="proposal.thematicDirections"
            :search="filteredThematicDirections"
            :selected="selectedThematicDirections"
            @change="setUpdate('thematicDirections', $event)"
            :disabled="disabled"
            @debounce-end="thematicDirectionsSearchString = $event.value"
            :valid="isFieldValid['thematicDirections']"
        />
        <ModelTextArea
            class="model-item"
            label="Описание"
            data-voicetext="Описание"
            required
            :value="proposal.description"
            @change="setUpdate('description', $event)"
            :valid="isFieldValid['description']"
            :disabled="disabled"
        />
        <ModelSelect
            class="model-item project_type"
            label="Тип проекта"
            data-voicetext="Тип проекта"
            required
            :value="proposal.type"
            @change="setUpdate('type', $event)"
            :items="projectTypesList"
            :disabled="disabled"
            :valid="isFieldValid['type']"
        />
        <ModelTextArea
            class="model-item"
            label="Цель"
            data-voicetext="Цель"
            :value="proposal.objective"
            @change="setUpdate('objective', $event)"
            :disabled="disabled"
        />
        <ModelTextArea
            class="model-item"
            label="Актуальность"
            data-voicetext="Актуальность"
            :value="proposal.relevance"
            @change="setUpdate('relevance', $event)"
            :disabled="disabled"
        />
        <div class="passport-links">
            <a class="passport-template" :href="passportTemplateUrl">Скачать шаблон</a>
            <a class="passport-template" :href="positionOrderLink" target="_blank">Положение о порядке отбора</a>
        </div>

        <div class="files">
            <ModelFile
                label="Загрузить карточку проекта"
                data-voicetext="Загрузить карточку проекта"
                required
                class="file"
                :value="proposal.passportFileId"
                @change="setUpdate('passportFileId', $event)"
                :accept="allowedFiles.join(',')"
                @remove="removepassportFileId"
                :disabled="disabled"
                :valid="isFieldValid['passportFileId']"
            />
            <ModelFile
                label="Загрузить дополнительные файлы"
                data-voicetext="Загрузить дополнительные файлы"
                class="file"
                multiple
                :value="proposal.attachments"
                @change="setUpdate('attachments', $event)"
                :accept="allowedFiles.join(',')"
                @remove="removeAttachment"
                :disabled="disabled"
            />
        </div>
        <p class="label_required" v-if="!disabled">
            <span class="required">&nbsp;&nbsp;*</span> — обязательные для заполнения поля
        </p>
        <div class="buttons" v-if="!disabled">
            <Button class="btn_send"  data-voicetext="Отправить на рассмотрение" :disabled="!canSendUpdate" @click="clickSend">Отправить на рассмотрение</Button>
            <Button v-if="proposal.id && proposal.status === 3" class="btn_save" data-voicetext="Сохранить" :disabled="!canSaveProposal" @click="clickSave"
                >Сохранить</Button
            >
        </div>

        <Dialog v-if="saving" is-popup :scrollable="false" :has-close-button="false">
            <div class="proposal-popup">
                <h1>Комментарий для администратора</h1>
                <p v-html="saving.comment_description"></p>
                <ModelTextArea v-model="saving.comment" label="Комментарий" />
                <div class="proposal-popup__buttons">
                    <Button
                        class="proposal-popup__comment-btn-send"
                        data-voicetext="Отправить"
                        @click="saving.confirm(saving.comment)"
                        :disabled="!saving.is_valid(saving.comment)"
                        >
                        Отправить
                    </Button>
                    <Button
                        class="proposal-popup__comment-btn-cancel"
                        outline
                        @click="saving.cancel"
                        data-voicetext="Отмена"
                    >
                        Отмена
                    </Button>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import ModelSelect from '../../UI/models/ModelSelect';
import ModelTextArea from '../../UI/models/ModelTextArea';
import ModelString from '../../UI/models/ModelString';
import ModelFile from '../../UI/models/ModelFileInput';
import ModelMultiAutoComplete from '../../UI/models/ModelMultiAutoComplete';
import Button from '../../UI/Button';
import Dialog from '../../UI/Dialog';

const getters = ['dictionaryByType'];
const actions = ['loadDictionaryItems'];

const validators = {
    name: (item) => !!item.name && item.name.length <= 255,
    type: (item) => !!item.type,
    thematicDirections: (item) => item.thematicDirections && item.thematicDirections.length > 0,
    description: (item) => !!item.description,
    passportFileId: (item) => item.passportFileId,
};

export default {
    name: 'ProposalForm',
    components: {
        ModelString,
        ModelTextArea,
        ModelSelect,
        ModelMultiAutoComplete,
        ModelFile,
        Button,
        Dialog,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        passportTemplateUrl: 'https://cms-prod.hb.bizmrg.com/files/_/IXXPcpJc/%D0%A4%D0%BE%D1%80%D0%BC%D0%B0%20%D0%BA%D0%B0%D1%80%D1%82%D0%BE%D1%87%D0%BA%D0%B8%20%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%BD%D0%BE%D0%B9%20%D0%B8%D0%BD%D0%B8%D1%86%D0%B8%D0%B0%D1%82%D0%B8%D0%B2%D1%8B.docx',
        positionOrderLink:
            'https://cms-prod.hb.bizmrg.com/files/_/APDgW17N/%D0%9B%D0%9D%D0%90_%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%20%D0%BF%D0%BE%D1%80%D1%8F%D0%B4%D0%BA%D0%B5%20%D0%BE%D1%82%D0%B1%D0%BE%D1%80%D0%B0,%20%D0%BF%D0%BE%D0%B4%D0%B4%D0%B5%D1%80%D0%B6%D0%BA%D0%B8%20%D0%B8%20%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B5%20%D0%BE%D1%86%D0%B5%D0%BD%D0%BA%D0%B8%20%D1%8D%D1%84%D1%84%D0%B5%D0%BA%D1%82%D0%B8%D0%B2%D0%BD%D0%BE%D1%81%D1%82%D0%B8%20%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%BE%D0%B2%20(%D1%80%D0%B5%D0%B4.%206).pdf',
        thematicDirectionsSearchString: '',
        dictionaries: ['projects_thematic_directions'],
        isFieldValid: {},
        isFormValid: false,
        loading: false,
        isCreatePopupOpen: true,
        saving: null,
        deleting: false,
        allowedFiles: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    }),
    computed: {
        ...mapGetters(getters),
        ...mapState('proposals', ['projectTypes', 'proposal', 'updatedFields']),
        projectTypesList() {
            return Object.entries(this.projectTypes).map((v) => ({ text: v[1].name, value: v[1].type }));
        },
        selectedThematicDirections() {
            return this.dictionaryByType('projects_thematic_directions').filter(
                (v) => this.proposal.thematicDirections.indexOf(v.id) > -1
            );
        },
        filteredThematicDirections() {
            let items = this.dictionaryByType('projects_thematic_directions');
            if (this.thematicDirectionsSearchString !== '') {
                items = items.filter((v) => v.field_value.includes(this.thematicDirectionsSearchString));
            }
            return items;
        },
        canSendUpdate() {
            return !this.loading && this.isFormValid;
        },
        canSaveProposal() {
            return !this.loading && this.isFormValid && Object.keys(this.updatedFields).length > 0;
        },
    },
    watch: {
        proposal: {
            handler(v) {
                this.isFormValid = Object.keys(validators)
                    .map((v) => validators[v](this.proposal))
                    .every((v) => v);

                this.isFieldValid = Object.keys(this.updatedFields).reduce((acc, v) => {
                    if (validators[v]) {
                        acc[v] = validators[v](this.proposal);
                    }
                    return acc;
                }, {});

                console.log('validate!', this.updatedFields);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions(actions),
        ...mapActions('proposals', [
            'createProposal',
            'saveProposal',
            'uploadFile',
            'updateProposal',
        ]),
        ...mapMutations('proposals', ['setProposalUpdate']),
        async setUpdate(key, value) {
            try {
                if (key === 'passportFileId') {
                    const uploaded = await this.uploadFile(value);
                    this.setProposalUpdate({
                        key,
                        value: uploaded && uploaded.length > 0 ? uploaded[0] : null,
                    });
                } else if (key === 'attachments') {
                    const uploaded = await this.uploadFile(value);
                    if (uploaded && uploaded.length > 0) {
                        const newAttachments = [
                            ...(this.proposal.attachments || []),
                            ...uploaded,
                        ];
                        this.setProposalUpdate({ key, value: newAttachments });
                    }
                } else {
                    this.setProposalUpdate({ key, value });
                }
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        },
        removepassportFileId(index) {
            let value = null;
            this.setProposalUpdate({ key: 'passportFileId', value });
        },
        removeAttachment(index) {
            let value = [...this.proposal.attachments];
            value.splice(index, 1);
            this.setProposalUpdate({ key: 'attachments', value });
        },
        async clickSend() {
            this.loading = true;

            try {
                const isUpdate = !!this.proposal.id;
                const comment_description = isUpdate
                    ? `Укажите доработки, которые внесли. <br> Комментарий является обязательным.`
                    : `Вы можете описать дополнительную информацию по инициативе.<br>Комментарий не является обязательным.`;

                let comment = await new Promise((confirm, cancel) => {
                    this.saving = {
                        comment_description,
                        is_comment_required: isUpdate,
                        is_valid: (comment) => !isUpdate || comment.trim().length > 0,
                        comment: '',
                        confirm: (comment) => {
                            this.saving = null;
                            confirm(comment);
                        },
                        cancel: () => {
                            this.saving = null;
                            cancel();
                        },
                    };
                });
                if (this.proposal.id) {
                    await this.updateProposal({ status: 2, comment });
                } else {
                    await this.createProposal(comment);
                    this.$router.push({ name: 'proposal', params: { id: this.proposal.id } });
                }
            } catch (e) {}
            this.loading = false;
        },
        async clickSave() {
            this.loading = true;
            await this.saveProposal();
            this.loading = false;
        },
    },
    mounted() {
        this.dictionaries.forEach((v) => {
            this.loadDictionaryItems(v);
        });
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';

.proposal-form {
    @include on-mobile {
        padding: mrem(32) mrem(18) mrem(48) mrem(14);
    }
}

.project_type {
    @include on-desktop {
        width: 50%;
    }
}

.passport-links {
    display: flex;
    flex-direction: column;

    @include on-desktop {
        flex-direction: row;
        gap: urem(32);
    }
}

.proposal-popup {
    &__buttons {
        display: flex;
        flex-direction: column;
        gap: urem(12);
        margin-bottom: urem(12);
        @include on-desktop {
            flex-direction: row;
            margin-bottom: 0;
        }
    }
    &__comment-btn-send,
    &__comment-btn-cancel {
        width: 100%;
        font-size: urem(14);
    }
}

.label_required {
    font-size: rem(18);
    line-height: rem(26);
    color: #2a2626;
    border-bottom: 1px solid #d2d5d9;
    margin-top: rem(40);
    margin-bottom: rem(40);
    padding-bottom: rem(40);

    @include on-mobile {
        font-size: mrem(16);
        line-height: mrem(24);
        border-bottom: none;
        padding-bottom: 0;
        margin-top: mrem(16);
        margin-bottom: mrem(40);
    }

    .required {
        color: #d1004a;
    }
}

.buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    @include on-mobile {
        flex-wrap: wrap;
    }

    .btn_send {
        background-color: #d1004a;
        width: rem(328);
        margin-right: rem(32);

        @include on-mobile {
            margin-right: 0;
            margin-bottom: mrem(24);
            width: 100%;
        }
    }

    .btn_save {
        background-color: #4663ab;
        width: rem(328);

        @include on-mobile {
            margin-right: 0;
            width: 100%;
        }
    }
}

.model-item {
    margin-bottom: rem(40);

    @include on-mobile {
        margin-bottom: mrem(40);
    }
}

.files {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;

    @include on-mobile {
        flex-wrap: wrap;
    }

    .file {
        width: 48%;

        @include on-mobile {
            margin-bottom: mrem(24);
            width: 100%;
        }
    }
}

.passport-template {
    display: block;
    font-style: normal;
    font-weight: 600;
    font-size: rem(18);
    line-height: rem(26);
    color: #4663ab;
    margin-bottom: rem(16);

    @include on-mobile {
        font-size: mrem(18);
        line-height: mrem(26);
        margin-bottom: mrem(16);
    }
}
</style>
